module.exports = __webpack_public_path__ + "img/firstlogo.3323feec.png";